/** Keep SETUP/ENTRY_OK unless must-haves break by a clear margin. */

import { blendedRsVsSpy } from "./checklistCommon.js";

export function momentumClearMarginFail(result) {
  const cmf = result?.cmf;
  if (cmf != null && cmf < -0.05) return true;
  const rsi = result?.rsi;
  if (rsi != null && rsi < 45) return true;
  const price = result?.price ?? result?.closes?.[0];
  const ema50 = result?.sm50 ?? result?.ema50;
  if (price != null && ema50 != null && price < ema50) return true;
  const rs = blendedRsVsSpy(result);
  if (rs != null && rs < -1) return true;
  return false;
}

export function putsClearMarginFail(result) {
  const cmf = result?.cmf;
  if (cmf != null && cmf > 0.05) return true;
  const rsi = result?.rsi;
  if (rsi != null && rsi > 55) return true;
  const price = result?.price ?? result?.closes?.[0];
  const ema50 = result?.sm50 ?? result?.ema50;
  if (price != null && ema50 != null && price > ema50) return true;
  const rs = blendedRsVsSpy(result);
  if (rs != null && rs > 1) return true;
  return false;
}

function bumpToAtLeastSetup(checklist, priorStatus) {
  if (!checklist) return checklist;
  if (priorStatus !== "SETUP" && priorStatus !== "ENTRY_OK") return checklist;
  if (checklist.status === "SETUP" || checklist.status === "ENTRY_OK") return checklist;
  return {
    ...checklist,
    status: "SETUP",
    reason: checklist.reason || "Holding prior setup (hysteresis)",
    hysteresis: true,
  };
}

export function applyMomentumHysteresis(checklist, priorStatus, result) {
  if (!checklist || !priorStatus) return checklist;
  if (momentumClearMarginFail(result)) return checklist;
  return bumpToAtLeastSetup(checklist, priorStatus);
}

export function applyPutsHysteresis(checklist, priorStatus, result) {
  if (!checklist || !priorStatus) return checklist;
  if (putsClearMarginFail(result)) return checklist;
  return bumpToAtLeastSetup(checklist, priorStatus);
}
